import React, { createContext, useContext, useState, useEffect } from "react";
import { fetchWebsiteSettings } from "../api";

const WebsiteSettingsContext = createContext();

export const useWebsiteSettings = () => {
  const context = useContext(WebsiteSettingsContext);
  if (!context) {
    throw new Error("useWebsiteSettings must be used within WebsiteSettingsProvider");
  }
  return context;
};

export const WebsiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    logo: "",
    icon: "",
    email: "",
    phone: "",
    address: "",
    mapLink: "",
    facebook: "",
    instagram: "",
    linkedin: "",
    twitter: "",
    youtube: "",
    description: "Discover luxury bedding, soft pillows, and timeless home decor crafted for your comfort and style.",
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    setIsLoading(true);
    const result = await fetchWebsiteSettings();
    // console.log(result);
    if (result.data?.data) {
      setSettings({
        logo: result.data.data.logo_url || settings.logo,
        icon: result.data.data.icon_url || settings.icon,
        email: result.data.data.email || settings.email,
        phone: result.data.data.phone || settings.phone,
        address: result.data.data.address || settings.address,
        mapLink: result.data.data.mapLink || settings.mapLink,
        facebook: result.data.data.facebook || settings.facebook,
        instagram: result.data.data.instagram || settings.instagram,
        linkedin: result.data.data.linkedin || settings.linkedin,
        twitter: result.data.data.twitter || settings.twitter,
        youtube: result.data.data.youtube || settings.youtube,
        description: result.data.data.description || settings.description,
      });
    }
    setIsLoading(false);
  };

  const refreshSettings = () => {
    loadSettings();
  };

  return (
    <WebsiteSettingsContext.Provider value={{ settings, isLoading, refreshSettings }}>
      {children}
    </WebsiteSettingsContext.Provider>
  );
};


